import { render, staticRenderFns } from "./report_grxx.vue?vue&type=template&id=b2ddc486&scoped=true"
import script from "./report_grxx.vue?vue&type=script&lang=js"
export * from "./report_grxx.vue?vue&type=script&lang=js"
import style0 from "./report_grxx.vue?vue&type=style&index=0&id=b2ddc486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ddc486",
  null
  
)

export default component.exports